import React from 'react';

const WaypointAlt = () => (
  <svg width="45px" height="36px" viewBox="0 0 45 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <defs />
    <g id="Extended-trials" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Fishtrack-Funnel---extended-trials" transform="translate(-964.000000, -317.000000)">
        <rect fill="#FFFFFF" x="0" y="0" width="1440" height="909" />
        <g id="FT/waypoint" transform="translate(965.000000, 318.000000)" strokeWidth="1.5">
          <path d="M43.6462374,33.7696686 C41.2874517,33.6554619 39.4859196,32.5228355 38.2156868,30.3428571 C36.917973,32.5270992 35.1277386,33.7358634 32.7414719,33.7358634 C30.3561213,33.7364725 28.5753526,32.5091307 27.2941274,30.3708759 C24.7518297,34.9053405 18.8339494,34.8992495 16.3221862,30.4004173 C15.0201976,32.5514633 13.2375968,33.7440863 10.8632386,33.7370816 C8.4803307,33.7285542 6.7056689,32.4902485 5.41558871,30.3446845 C4.13802764,32.5514633 2.32031228,33.6536346 0,33.7760642" id="Page-1" stroke="#67D3DF" />
          <path d="M21.75,27.5 C27.9166667,19.1666667 31,13.3333333 31,10 C31,5 28,0 21.5,0 C15,1.1832736e-15 12.5,5 12.5,10 C12.5,13.3333333 15.5833333,19.1666667 21.75,27.5 Z" id="Path-3" stroke="#011D38" />
          <circle id="Oval" stroke="#011D38" cx="21.75" cy="9" r="3" />
        </g>
      </g>
    </g>
  </svg>
);

export default WaypointAlt;
